import { useState, useCallback, useEffect } from 'react';
import localforage from 'localforage';

import Session from '../services/session';

const useStorageAuth = () => {
  const [authStorageData, setAuthStorageData] = useState({
    token: null,
    refreshToken: null,
    userImage: null,
    userType: null,
    userName: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setIsLoading(true);

        setAuthStorageData(await Session.readAll());
      } catch (error) {
        console.error('Erro ao carregar dados do storage:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadInitialData();
  }, []);

  const setAuthStorageItem = useCallback(async (key, value) => {
    if (value === null || value === undefined) {
      return;
    }

    try {
      await localforage.setItem(key, value);
      setAuthStorageData(prev => ({ ...prev, [key]: value }));
    } catch (error) {
      console.error(`Erro ao salvar ${key} no storage:`, error);
    }
  }, []);

  const removeAuthStorageItem = useCallback(async key => {
    try {
      await localforage.removeItem(key);
      setAuthStorageData(prev => ({ ...prev, [key]: null }));
    } catch (error) {
      console.error(`Erro ao remover ${key} do storage:`, error);
    }
  }, []);

  const clearAuthStorage = useCallback(async () => {
    try {
      await Session.clear();
      setAuthStorageData({
        token: null,
        refreshToken: null,
        userImage: null,
        userType: null,
        userName: null,
      });
    } catch (error) {
      console.error('Erro ao limpar storage:', error);
    }
  }, []);

  return [
    authStorageData,
    setAuthStorageItem,
    removeAuthStorageItem,
    clearAuthStorage,
    isLoading,
  ];
};

export default useStorageAuth;
